import "./accountsInfo.css";
import { useState } from "react";
import { useSelector } from "react-redux";
import PersonalInfo from "./UpdateAccountDetails/PersonalInfo";
import UpdatePassword from "./UpdateAccountDetails/UpdatePassword";
import ShippingAddress from "./UpdateAccountDetails/ShippingAddress";

const AccountWrapper = () => {
  const [activeTab, setActiveTab] = useState("personal");
  const isDarkMode = useSelector((state) => state?.theme?.darkMode);
  const provider = useSelector((state) => state?.auth?.user?.provider);

  const renderContent = () => {
    switch (activeTab) {
      case "personal":
        return <PersonalInfo />;
      case "shipping":
        return <ShippingAddress />;
      case "password":
        return <UpdatePassword />;
      default:
        return <PersonalInfo />;
    }
  };

  return (
    <div className={`myaccount-container ${isDarkMode ? "dark" : "light"}`}>
      <div className="myaccount-content">
        <div className="myaccount-tabs">
          <button
            className={`myaccount-tab ${
              activeTab === "personal" ? "active" : ""
            }`}
            onClick={() => setActiveTab("personal")}
          >
            Personal Information
          </button>
          <button
            className={`myaccount-tab ${
              activeTab === "shipping" ? "active" : ""
            }`}
            onClick={() => setActiveTab("shipping")}
          >
            Shipping Address
          </button>
          {provider === "google" || provider === "facebook" ? null : (
            <button
              className={`myaccount-tab ${
                activeTab === "password" ? "active" : ""
              }`}
              onClick={() => setActiveTab("password")}
            >
              Change Password
            </button>
          )}
        </div>

        {/* Content Section */}
        <div
          className={`myaccount-main ${
            isDarkMode ? "myaccount-main-dark" : ""
          }`}
        >
          {renderContent()}
        </div>
      </div>
    </div>
  );
};

export default AccountWrapper;
